import script from "./OfferDocForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferDocForm.vue?vue&type=script&setup=true&lang=js"

import "./OfferDocForm.vue?vue&type=style&index=0&id=9ae18f88&scoped=true&lang=css"
import "./OfferDocForm.vue?vue&type=style&index=1&id=9ae18f88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae18f88"]])

export default __exports__